import { createIcon } from '@chakra-ui/react';

export const ShiningStar = createIcon({
  displayName: 'ShiningStar',
  viewBox: '0 0 48 48',
  path: (
    <g id="SJ-Icon-B_Influencers_Red_RGB">
      <path
        id="Path_2277"
        data-name="Path 2277"
        d="M384.65,704.808a1.161,1.161,0,0,1-1.161-1.161v-4.082a1.161,1.161,0,0,1,2.323,0v4.082A1.161,1.161,0,0,1,384.65,704.808Z"
        transform="translate(-360.649 -656.808)"
        fill="#d11947"
      />
      <path
        id="Path_2278"
        data-name="Path 2278"
        d="M506.727,680.513a1.162,1.162,0,0,1-1.073-.717l-1.562-3.771a1.161,1.161,0,1,1,2.146-.889l1.562,3.771a1.162,1.162,0,0,1-1.073,1.606Z"
        transform="translate(-473.986 -634.251)"
        fill="#d11947"
      />
      <path
        id="Path_2279"
        data-name="Path 2279"
        d="M610.223,611.359a1.158,1.158,0,0,1-.821-.34l-2.886-2.886a1.161,1.161,0,0,1,1.643-1.643l2.886,2.886a1.161,1.161,0,0,1-.821,1.983Z"
        transform="translate(-570.073 -570.049)"
        fill="#d11947"
      />
      <path
        id="Path_2280"
        data-name="Path 2280"
        d="M679.365,507.855a1.158,1.158,0,0,1-.444-.089L675.15,506.2a1.161,1.161,0,0,1,.889-2.146l3.771,1.562a1.162,1.162,0,0,1-.445,2.235Z"
        transform="translate(-634.265 -473.954)"
        fill="#d11947"
      />
      <path
        id="Path_2281"
        data-name="Path 2281"
        d="M703.646,385.777h-4.082a1.161,1.161,0,0,1,0-2.323h4.082a1.161,1.161,0,0,1,0,2.323Z"
        transform="translate(-656.808 -360.616)"
        fill="#d11947"
      />
      <path
        id="Path_2282"
        data-name="Path 2282"
        d="M675.582,240.587a1.162,1.162,0,0,1-.445-2.235l3.771-1.562a1.161,1.161,0,1,1,.889,2.146l-3.771,1.562A1.159,1.159,0,0,1,675.582,240.587Z"
        transform="translate(-634.253 -222.604)"
        fill="#d11947"
      />
      <path
        id="Path_2283"
        data-name="Path 2283"
        d="M607.311,117.514a1.161,1.161,0,0,1-.821-1.983l2.886-2.886a1.161,1.161,0,1,1,1.642,1.642l-2.886,2.886A1.158,1.158,0,0,1,607.311,117.514Z"
        transform="translate(-570.049 -105.616)"
        fill="#d11947"
      />
      <path
        id="Path_2284"
        data-name="Path 2284"
        d="M505.131,35.274a1.162,1.162,0,0,1-1.073-1.606l1.562-3.771a1.161,1.161,0,0,1,2.146.889L506.2,34.556A1.162,1.162,0,0,1,505.131,35.274Z"
        transform="translate(-473.954 -27.441)"
        fill="#d11947"
      />
      <path
        id="Path_2285"
        data-name="Path 2285"
        d="M384.615,6.4a1.161,1.161,0,0,1-1.161-1.161V1.161a1.161,1.161,0,0,1,2.323,0V5.243A1.161,1.161,0,0,1,384.615,6.4Z"
        transform="translate(-360.616 0)"
        fill="#d11947"
      />
      <path
        id="Path_2286"
        data-name="Path 2286"
        d="M239.427,35.285a1.162,1.162,0,0,1-1.073-.717L236.791,30.8a1.161,1.161,0,0,1,2.146-.889l1.562,3.771a1.162,1.162,0,0,1-1.073,1.606Z"
        transform="translate(-222.605 -27.452)"
        fill="#d11947"
      />
      <path
        id="Path_2287"
        data-name="Path 2287"
        d="M116.352,117.539a1.158,1.158,0,0,1-.821-.34l-2.886-2.886a1.161,1.161,0,0,1,1.642-1.642l2.886,2.886a1.161,1.161,0,0,1-.821,1.983Z"
        transform="translate(-105.615 -105.64)"
        fill="#d11947"
      />
      <path
        id="Path_2288"
        data-name="Path 2288"
        d="M34.111,240.62a1.158,1.158,0,0,1-.444-.089L29.9,238.969a1.161,1.161,0,1,1,.889-2.146l3.771,1.562a1.162,1.162,0,0,1-.445,2.235Z"
        transform="translate(-27.44 -222.635)"
        fill="#d11947"
      />
      <path
        id="Path_2289"
        data-name="Path 2289"
        d="M5.243,385.812H1.161a1.161,1.161,0,0,1,0-2.323H5.243a1.161,1.161,0,0,1,0,2.323Z"
        transform="translate(0 -360.649)"
        fill="#d11947"
      />
      <path
        id="Path_2290"
        data-name="Path 2290"
        d="M30.354,507.887a1.162,1.162,0,0,1-.445-2.235l3.771-1.562a1.161,1.161,0,0,1,.889,2.146L30.8,507.8A1.158,1.158,0,0,1,30.354,507.887Z"
        transform="translate(-27.454 -473.984)"
        fill="#d11947"
      />
      <path
        id="Path_2291"
        data-name="Path 2291"
        d="M113.49,611.384a1.161,1.161,0,0,1-.821-1.983l2.886-2.887a1.161,1.161,0,1,1,1.642,1.642l-2.886,2.887A1.158,1.158,0,0,1,113.49,611.384Z"
        transform="translate(-105.639 -570.072)"
        fill="#d11947"
      />
      <path
        id="Path_2292"
        data-name="Path 2292"
        d="M237.9,680.527a1.162,1.162,0,0,1-1.073-1.606l1.562-3.771a1.161,1.161,0,0,1,2.146.889l-1.562,3.771A1.162,1.162,0,0,1,237.9,680.527Z"
        transform="translate(-222.635 -634.265)"
        fill="#d11947"
      />
      <g
        id="Group_2626"
        data-name="Group 2626"
        transform="translate(11.047 10.715)"
      >
        <path
          id="Path_2293"
          data-name="Path 2293"
          d="M191.626,204.748a1.938,1.938,0,0,1-1.841-2.535l2.166-6.668-5.672-4.121a1.936,1.936,0,0,1,1.138-3.5h7.011l2.166-6.668a1.936,1.936,0,0,1,3.682,0h0l2.166,6.668h7.011a1.936,1.936,0,0,1,1.138,3.5l-5.672,4.121,2.166,6.668a1.936,1.936,0,0,1-2.979,2.164l-5.672-4.121-5.672,4.121A1.932,1.932,0,0,1,191.626,204.748Zm6.81-7.088a1.159,1.159,0,0,1,.683.222l5.391,3.916-2.059-6.337a1.161,1.161,0,0,1,.422-1.3l5.39-3.916H201.6a1.161,1.161,0,0,1-1.1-.8l-2.059-6.337-2.059,6.337a1.161,1.161,0,0,1-1.1.8h-6.663L194,194.162a1.161,1.161,0,0,1,.422,1.3l-2.059,6.337,5.391-3.916A1.16,1.16,0,0,1,198.435,197.66Z"
          transform="translate(-185.481 -179.918)"
          fill="#d11947"
        />
      </g>
    </g>
  ),
});
